/* eslint-disable @typescript-eslint/no-unused-vars */
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { table, cadastro } from '../../dados/vendedores/vendedores.dado';
import { useContext, useEffect, useState } from 'react';
import { useApi } from '../../hooks/userApi';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { Box, Paper, SelectChangeEvent } from '@mui/material';
import BtnPesquisa from '../../components/BtnPesquisa/BtnPesquisa';
import { PaginationComponent } from '../../components/tables/footerTableAction/footerTableAction-style';
import React from 'react';
import { formatDinheiro } from 'utils/formatDinheiro';
import EditVendedores from './editVendedores.template';
import TablePrimary from 'components/tables/tablePrimary/tablePrimary';
import ModalDelete from 'components/ModalDelete/ModalDelete.component';
import ModalPassword from 'components/ModalPassword/ModalPassword.component';
import { formataPorcentagem } from 'utils/formataPorcentagem';
import { maskTelefone } from 'utils/maskTelefone';

const api = useApi();

export default function Vendedores() {
  const [vendedores, setVendedores] = useState([]);
  const [vend, setVend] = useState();
  const [edit, setEdit] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [allVendedores, setAllVendedores] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Editar', 'Excluir', 'Gerenciar'].includes(column)),
  );
  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  //Parte do modal pass
  const [openPass, setOpenPass] = useState(false);
  const [itemPass, setItemPass] = useState('');

  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = useContext(LoadingContext);

  const getAllVendedores = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/vendedor?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/vendedor?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllVendedores(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(
        '/vendedor' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((r) => {
        if (!r.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setLoading(false);
        setPageTotal(r.page_total);
        setVendedores(r.results);
      })
      .catch((err) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllVendedores();
  }, [page, like, selectedFilterColumns]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleEditar = (row: any) => {
    setVend(row);
    setEdit(true);
  };

  const handleUpdateVendedor = () => {
    setPage(1);
    setLoading(true);
    api
      .get(
        '/vendedor' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((r) => {
        if (!r.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setLoading(false);
        setPageTotal(r.page_total);
        setVendedores(r.results);
      })
      .catch((err) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });

    getAllVendedores();
  };

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/usuario/');
    setItemExclude(row);
    setOpen(true);
  };

  //Parte do modal password
  const handlePass = (id: string) => {
    setItemPass(id);
    setOpenPass(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: formataPorcentagem(row?.comissao) || '-', onClick: null, link: false },
          { campo: maskTelefone(row?.contato) || '-', onClick: null, link: false },
          { campo: 'Usuário', onClick: () => handlePass(row.id), link: true },
          { campo: 'Editar', onClick: () => handleEditar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(vendedores),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allVendedores),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      setSelectedFilterColumns(JSON.parse(savedColumns));
    }
  }, []);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const excludedColumns = ['Editar', 'Excluir'];
    const updatedFilterColumns = filteredColumns.filter((column) => !excludedColumns.includes(column));
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path} // path  do delete
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          allData={arrListAll}
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
        />
      )}
      {edit && <EditVendedores dado={vend} setEdit={() => setEdit(false)} onUpdate={handleUpdateVendedor} />}
      <ModalPassword path={'passAdmin'} id={itemPass} open={openPass} setOpen={setOpenPass} />
    </>
  );
}
